export const envVariables = {
  local: {
    DIRECTA: {
      REACT_APP_API_BASE_URL: 'http://localhost:8080/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LeEcKEUAAAAAPnQn-EcFBwAiQndaHKQXv7JXUo9',
      REACT_APP_SITE_TITLE: 'DEV Merchant Panel',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    POVILE: {
      REACT_APP_API_BASE_URL: 'http://localhost:8080/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LeEcKEUAAAAAPnQn-EcFBwAiQndaHKQXv7JXUo9',
      REACT_APP_SITE_TITLE: 'DEV Povile Payments Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    LIMEPAY: {
      REACT_APP_API_BASE_URL: 'http://localhost:8080/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Le4v5MoAAAAANeGU-V6DYXKuQswDIG4vVOtivva',
      REACT_APP_SITE_TITLE: 'DEV Lime Pay Payments Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/limepay-favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/limepay-favicon.png?v=2',
    },
    ONEKEY_PAYMENTS: {
      REACT_APP_API_BASE_URL: 'http://localhost:8080/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Lc2EmEmAAAAAL8nLzkTxXQFCi5ui5BKkiTZC9bQ',
      REACT_APP_SITE_TITLE: 'DEV One Key Payments Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    TUPAY: {
      REACT_APP_API_BASE_URL: 'http://localhost:8080/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LeEcKEUAAAAAPnQn-EcFBwAiQndaHKQXv7JXUo9',
      REACT_APP_SITE_TITLE: 'DEV Tupay Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    GATEWAY_DEPOSIT: {
      REACT_APP_API_BASE_URL: 'http://localhost:8080/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Ld2m08qAAAAADdiJEob388JCFIDsq9pNffN2v_v',
      REACT_APP_SITE_TITLE: 'DEV Gateway Deposit Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    ZIMO: {
      REACT_APP_API_BASE_URL: 'http://localhost:8080/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LdFu3sqAAAAACZvLvqLHXj9irbJAL5hI7bgChSO',
      REACT_APP_SITE_TITLE: 'DEV Zimo',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
  },
  dev: {
    DIRECTA: {
      REACT_APP_API_BASE_URL: 'https://merchant-panel-api.dev.directa24.net/v1',
      REACT_APP_WEB_URL_PROD: 'https://merchants.d24.com',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Le_NVUlAAAAAKYuvCctuQuoNvtKmb28L_J_R8rN',
      REACT_APP_SITE_TITLE: 'DEV Merchant Panel',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    POVILE: {
      REACT_APP_API_BASE_URL: 'https://merchant-panel-api.dev.directa24.net/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: 'EXAMPLE_6Le_NVUlAAAAAKYuvCctuQuoNvtKmb28L_J_',
      REACT_APP_SITE_TITLE: 'DEV Povile Payments Panel',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    LIMEPAY: {
      REACT_APP_API_BASE_URL: 'https://merchant-panel-api.dev.directa24.net/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Le4v5MoAAAAANeGU-V6DYXKuQswDIG4vVOtivva',
      REACT_APP_SITE_TITLE: 'DEV Lime Pay Payments Panel',
      REACT_APP_SITE_FAVICON: '/limepay-favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/limepay-favicon.png?v=2',
    },
    ONEKEY_PAYMENTS: {
      REACT_APP_API_BASE_URL: 'https://merchant-panel-api.dev.directa24.net/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Lc2EmEmAAAAAL8nLzkTxXQFCi5ui5BKkiTZC9bQ',
      REACT_APP_SITE_TITLE: 'DEV Onekey Payments',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    TUPAY: {
      REACT_APP_API_BASE_URL: 'https://merchant-panel-api-tupayonline.dev.directa24.net/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LeEcKEUAAAAAPnQn-EcFBwAiQndaHKQXv7JXUo9',
      REACT_APP_SITE_TITLE: 'DEV Tupay Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    GATEWAY_DEPOSIT: {
      REACT_APP_API_BASE_URL: 'https://merchant-panel-api.dev.directa24.net/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Ld2m08qAAAAADdiJEob388JCFIDsq9pNffN2v_v',
      REACT_APP_SITE_TITLE: 'DEV Gateway Deposit Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    ZIMO: {
      REACT_APP_API_BASE_URL: 'https://merchant-panel-api.dev.directa24.net/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LdFu3sqAAAAACZvLvqLHXj9irbJAL5hI7bgChSO',
      REACT_APP_SITE_TITLE: 'DEV ZIMO Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
  },
  stg: {
    DIRECTA: {
      REACT_APP_API_BASE_URL: 'https://merchants-api-stg.d24.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Le_NVUlAAAAAKYuvCctuQuoNvtKmb28L_J_R8rN',
      REACT_APP_SITE_TITLE: 'STG Merchant Panel',
      REACT_APP_WEB_URL_PROD: 'https://merchants.d24.com',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    POVILE: {
      REACT_APP_API_BASE_URL: 'https://merchants-api-stg.povilepayments.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Lcb6vMmAAAAALk0WW3BD2r61uwwufWl7ZonG7u0',
      REACT_APP_SITE_TITLE: 'STG Povile Payments Panel',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    LIMEPAY: {
      REACT_APP_API_BASE_URL: 'https://merchants-api-stg.lime-pay.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Le4v5MoAAAAANeGU-V6DYXKuQswDIG4vVOtivva',
      REACT_APP_SITE_TITLE: 'STG Lime Pay Payments Panel',
      REACT_APP_SITE_FAVICON: '/limepay-favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/limepay-favicon.png?v=2',
    },
    ONEKEY_PAYMENTS: {
      REACT_APP_API_BASE_URL: 'https://merchants-api-stg.onekeypayments.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Lc2EmEmAAAAAL8nLzkTxXQFCi5ui5BKkiTZC9bQ',
      REACT_APP_SITE_TITLE: 'STG Onekey Payments',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    TUPAY: {
      REACT_APP_API_BASE_URL: 'https://merchants-api-stg.tupayonline.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LeEcKEUAAAAAPnQn-EcFBwAiQndaHKQXv7JXUo9',
      REACT_APP_SITE_TITLE: 'STG Tupay Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    GATEWAY_DEPOSIT: {
      REACT_APP_API_BASE_URL: 'https://merchants-api-stg.gatewaydeposit.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Ld2m08qAAAAADdiJEob388JCFIDsq9pNffN2v_v',
      REACT_APP_SITE_TITLE: 'STG Gateway Deposit Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    ZIMO: {
      REACT_APP_API_BASE_URL: 'https://merchants-api-stg.zimo-pagos.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LdFu3sqAAAAACZvLvqLHXj9irbJAL5hI7bgChSO',
      REACT_APP_SITE_TITLE: 'STG ZIMO Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
  },
  prd: {
    DIRECTA: {
      REACT_APP_API_BASE_URL: 'https://merchants-api.d24.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Le_NVUlAAAAAKYuvCctuQuoNvtKmb28L_J_R8rN',
      REACT_APP_SITE_TITLE: 'Merchant Panel',
      REACT_APP_WEB_URL_PROD: 'https://merchants.d24.com',
      ANALYTICS_ID: 'G-M3ZKNV83W4',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    POVILE: {
      REACT_APP_API_BASE_URL: 'https://merchants-api.povilepayments.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Lcb6vMmAAAAACaBV3YnmlrD9DFVUpnYaqXOiu1P',
      REACT_APP_SITE_TITLE: 'Povile Payments Panel',
      ANALYTICS_ID: 'G-3ZL780C959',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    LIMEPAY: {
      REACT_APP_API_BASE_URL: 'https://merchants-api.lime-pay.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Le4v5MoAAAAANeGU-V6DYXKuQswDIG4vVOtivva',
      REACT_APP_SITE_TITLE: 'Lime Pay Payments Panel',
      REACT_APP_SITE_FAVICON: '/limepay-favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/limepay-favicon.png?v=2',
    },
    ONEKEY_PAYMENTS: {
      REACT_APP_API_BASE_URL: 'https://merchants-api.onekeypayments.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Lc2EmEmAAAAAL8nLzkTxXQFCi5ui5BKkiTZC9bQ',
      REACT_APP_SITE_TITLE: 'Onekey Payments',
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    TUPAY: {
      REACT_APP_API_BASE_URL: 'https://merchants-api.tupayonline.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LeefhUjAAAAALI87kSWa75GWpbvy9ctKtZTscZy',
      REACT_APP_SITE_TITLE: 'Tupay Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    GATEWAY_DEPOSIT: {
      REACT_APP_API_BASE_URL: 'https://merchants-api.gatewaydeposit.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6Ld2m08qAAAAADdiJEob388JCFIDsq9pNffN2v_v',
      REACT_APP_SITE_TITLE: 'Gateway Deposit Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
    ZIMO: {
      REACT_APP_API_BASE_URL: 'https://merchants-api.zimo-pagos.com/v1',
      REACT_APP_RECAPTCHA_SITE_KEY: '6LdFu3sqAAAAACZvLvqLHXj9irbJAL5hI7bgChSO',
      REACT_APP_SITE_TITLE: 'ZIMO Panel',
      SKIP_PREFLIGHT_CHECK: true,
      REACT_APP_SITE_FAVICON: '/favicon.ico?v=2',
      REACT_APP_SITE_FAVICON_PNG: '/favicon.png?v=2',
    },
  },
};
